import { toast } from 'react-hot-toast';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export function safeToast(type: ToastType, msg: string) {
  try {
    switch (type) {
      case 'success':
        toast.success(String(msg));
        return;
      case 'error':
        toast.error(String(msg));
        return;
      case 'warning':
        toast(String(msg));
        return;
      case 'info':
      default:
        toast(String(msg));
        return;
    }
  } catch (_e) {
    try {
      // final fallback
      (window as any).alert(String(msg));
    } catch (_e2) {
       
      console.log(String(msg));
    }
  }
}

export default safeToast;
